export const formatSimpleMarkdownAsHtml = (text: string) => {
    if (!text) {
        return text;
    }
    const parts = text.split('**');
    if (parts.length === 1) {
        return text;
    }
    let result = '';
    let openingBoldTag = true;
    for (let idx = 0; idx <= parts.length - 1; idx++) {
        const part = parts[idx];
        result += part;
        if (idx < parts.length - 1) {
            if (openingBoldTag) {
                result += '<b>';
            } else {
                result += '</b>';
            }
        }
        openingBoldTag = !openingBoldTag;
    }
    return result;
};
